import React from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faCloudDownloadAlt, faLink } from '@fortawesome/fontawesome-free-solid'
import {
  faTwitter,
  faGithub,
  faLinkedin,
  faXing,
  faKeybase,
} from '@fortawesome/fontawesome-free-brands'

import { Text } from './Layout'

const SocialLinkStyle = ({ children }) => (
  <Text color="black" textDecorationColor="orange" hover={{ color: 'orange' }}>
    {children}
  </Text>
)

const SocalLinks = () => (
  <Text>
    <a href="https://twitter.com/drivebytesting/">
      <SocialLinkStyle>
        <FontAwesomeIcon icon={faTwitter} size="xs" />
      </SocialLinkStyle>
    </a>
    &nbsp;
    <a href="https://github.com/lukaspustina">
      <SocialLinkStyle>
        <FontAwesomeIcon icon={faGithub} size="xs" />
      </SocialLinkStyle>
    </a>
    &nbsp;
    <a href="https://www.linkedin.com/in/lukaspustina">
      <SocialLinkStyle>
        <FontAwesomeIcon icon={faLinkedin} size="xs" />
      </SocialLinkStyle>
    </a>
    &nbsp;
    <a href="https://www.xing.com/profile/Lukas_Pustina/">
      <SocialLinkStyle>
        <FontAwesomeIcon icon={faXing} size="xs" />
      </SocialLinkStyle>
    </a>
    &nbsp;
    <a href="https://keybase.io/lukaspustina">
      <SocialLinkStyle>
        <FontAwesomeIcon icon={faKeybase} size="xs" />
      </SocialLinkStyle>
    </a>
  </Text>
)

const DownloadLink = ({ link }) => (
  <a href={link}>
    <Text color="black" hover={{ color: 'orange' }}>
      <FontAwesomeIcon icon={faCloudDownloadAlt} size="xs" />
    </Text>
  </a>
)

const GithubLink = ({ repo }) => (
  <a href={repo}>
    <Text color="black" hover={{ color: 'orange' }}>
      <FontAwesomeIcon icon={faGithub} size="xs" />
    </Text>
  </a>
)

const WebsiteLink = ({ link }) => (
  <a href={link}>
    <Text color="black" hover={{ color: 'orange' }}>
      <FontAwesomeIcon icon={faLink} size="xs" />
    </Text>
  </a>
)

export { SocalLinks, DownloadLink, GithubLink, WebsiteLink }



// WEBPACK FOOTER //
// ./src/components/SocialLinks.js